import script from "./managementEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./managementEditModal.vue?vue&type=script&setup=true&lang=js"

import "./managementEditModal.vue?vue&type=style&index=0&id=46ab988c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ab988c"]])

export default __exports__